import { useLocation } from 'react-router-dom';
import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateBase } from 'base/src/store/baseStore';
import { PathName } from 'base/src/utils/routeUtil';
import CarteiraValor from '../CarteiraValor';

const connector = connectState(
  (state: RootStateBase) => ({
    headerIgnore: state.UtilReducer.HeaderIgnore,
  })
);

export interface CarteiraValorFallbackProps extends PropsFromRedux<typeof connector> {}

function CarteiraValorFallback(props: CarteiraValorFallbackProps) {
  const location = useLocation();

  const headerHidden =
    props.headerIgnore &&
    (props.headerIgnore.includes('*') || props.headerIgnore.includes(PathName(location.pathname)));

  if (!headerHidden) return null;

  return <CarteiraValor />;
}

export default connector(CarteiraValorFallback);
